import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { setJoinBy, setTargetChair, setTargetRoom, setUserToUnfocus } from "../../store/ProductivitySessionSlice";
import { occupyChair } from "../../../Map/store/Chairs/ChairsThunk";
import { joinRoom } from "../../../ControlPanel/store/interact/interactThunks";
import { startPause } from "../../../CoffeePause/store/coffePauseSlice";
import { addBreakTime } from "../../../CoffeePause/store/coffePauseThunks";
import { addNotification } from "../../../Notifications/store/notificationsSlice";
import NotificationBuilder from "../../../Notifications/utils/NotificationBuilder";

const StopFocus = ({ onClose }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const {
        sessionView,
        targetChair,
        joinBy,
        targetRoom
    } = useSelector((state) => state.productivitySession);

    const {
        localAvatar
    } = useSelector((state) => state.auth);

    const leaveAlone = () => {
        dispatch(setTargetChair(null));
        dispatch(setTargetRoom(null));
        dispatch(setJoinBy(null));
        onClose();
    }

    const enterRoom = async () => {
        if (joinBy === "chair") {
            if (targetChair && localAvatar.focus_state === 1 && sessionView === 'progress') {
                await dispatch(occupyChair({
                    body: {
                        currentChairId: localAvatar.chair_id,
                        targetChairId: targetChair
                    }
                }));
                dispatch(setTargetChair(null));
                dispatch(setJoinBy(null));
                onClose();
            }
        } else if (joinBy === "room") {
            if (targetRoom && localAvatar.focus_state === 1 && sessionView === 'progress') {
                await dispatch(joinRoom({
                    body: {
                        targetRoomId: targetRoom
                    }
                }));
                dispatch(setTargetRoom(null));
                dispatch(setJoinBy(null));
                onClose();
            }
        }
        else if (joinBy === "coffee") {
            if (targetRoom && localAvatar.focus_state === 1 && sessionView === 'progress') {

                await dispatch(joinRoom({ body: { targetRoomId: targetRoom } })).unwrap();
                dispatch(startPause(localAvatar.id));
                const onlyTime = new Date().toTimeString().split(' ')[0];
                dispatch(addBreakTime({ body: { userId: localAvatar.id, time: onlyTime } }));
                const notification = NotificationBuilder.info()
                    .withHeader('start_pause', true)
                    .build();
                dispatch(addNotification(notification));
                dispatch(setTargetRoom(null));
                dispatch(setJoinBy(null));
                onClose();

            }
        }

    }
    return (
        <>
            <div className="session-content-text">
                <span className="session-title">
                    {t("session_in_progress")}
                </span>
                <span className="session-subtitle">
                    {t("change_room_session")}
                </span>
            </div>
            <div className="session-button-container">
                <button
                    type="button"
                    className="session-enter-button"
                    onClick={() => enterRoom()}
                >
                    {t("yes_stop")}
                </button>
                <button
                    type="button"
                    className="session-button"
                    onClick={() => leaveAlone()}
                >
                    {t("resume_session")}
                </button>
            </div>


        </>
    );
};

export default StopFocus;